// export const BASE_URL = "http://localhost:8080";
export const BASE_URL = "https://projects-stg.eflag.in:8443";
export const BASE_FRONTEND_URL = "http://localhost:8080";

const AppConfig = {
  colorPalette: {
    primary: {
      main: "#b41660",
      light: "#f7a2cc",
      dark: "#2980b9",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#e74c3c",
      light: "#f1e5e9",
      dark: "#c0392b",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f0f0f0",
      paper: "#ffffff",
    },
    text: {
      primary: "#333333",
      secondary: "#666666",
      disabled: "#bdbdbd",
      dark: "#000000",
    },
    error: {
      main: "#f44336",
      light: "#e57373",
      dark: "#d32f2f",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ff9800",
      light: "#ffb74d",
      dark: "#f57c00",
      contrastText: "#ffffff",
    },
    info: {
      main: "#2196f3",
      light: "#64b5f6",
      dark: "#1976d2",
      contrastText: "#ffffff",
    },
    success: {
      main: "#4caf50",
      light: "#81c784",
      dark: "#388e3c",
      contrastText: "#ffffff",
    },
  },
  stateCities: [
    { state: "Maharashtra", city: "Mumbai" },
    { state: "Maharashtra", city: "Pune" },
    { state: "Gujarat", city: "Ahmedabad" },
    { state: "Gujarat", city: "Surat" },
    { state: "Delhi", city: "New Delhi" },
    { state: "Karnataka", city: "Bengaluru" },
    { state: "Karnataka", city: "Mysuru" },
    { state: "Tamil Nadu", city: "Chennai" },
    { state: "Tamil Nadu", city: "Coimbatore" },
    { state: "West Bengal", city: "Kolkata" },
    { state: "West Bengal", city: "Siliguri" },
    { state: "Rajasthan", city: "Jaipur" },
    { state: "Rajasthan", city: "Udaipur" },
    { state: "Punjab", city: "Chandigarh" },
    { state: "Punjab", city: "Amritsar" },
    { state: "Haryana", city: "Gurgaon" },
    { state: "Haryana", city: "Faridabad" },
    { state: "Uttar Pradesh", city: "Lucknow" },
    { state: "Uttar Pradesh", city: "Noida" },
    { state: "Madhya Pradesh", city: "Indore" },
    { state: "Madhya Pradesh", city: "Bhopal" },
    { state: "Kerala", city: "Kochi" },
    { state: "Kerala", city: "Thiruvananthapuram" },
    { state: "Andhra Pradesh", city: "Hyderabad" },
    { state: "Andhra Pradesh", city: "Vijayawada" },
    { state: "Telangana", city: "Secunderabad" },
    { state: "Jharkhand", city: "Ranchi" },
    { state: "Assam", city: "Guwahati" },
    { state: "Bihar", city: "Patna" },
    { state: "Odisha", city: "Bhubaneswar" },
    { state: "Goa", city: "Panaji" },
    { state: "Chhattisgarh", city: "Raipur" },
    { state: "Himachal Pradesh", city: "Shimla" },
    { state: "Jammu and Kashmir", city: "Srinagar" },
    { state: "Ladakh", city: "Leh" },
    { state: "Sikkim", city: "Gangtok" },
    { state: "Arunachal Pradesh", city: "Itanagar" },
    { state: "Nagaland", city: "Kohima" },
    { state: "Manipur", city: "Imphal" },
    { state: "Meghalaya", city: "Shillong" },
    { state: "Tripura", city: "Agartala" },
    { state: "Andaman and Nicobar Islands", city: "Port Blair" },
  ],
  "2b73c160-6d82-4c50-9a1e-65484800ed72": [
    { title: "SIL Approval", isTitle: true, activeStep: 1 },
    { title: "Initiated", isTitle: false, activeStep: 1 },
    { title: "OMC - Approval", isTitle: true, activeStep: 1 },
    { title: "OMC - NOC", isTitle: true, activeStep: 1 },

    { title: "Authority - Approval", isTitle: true, activeStep: 1 },
    { title: "Authority - NOC", isTitle: true, activeStep: 1 },
    { title: "Installation", isTitle: true, activeStep: 1 },
    // { title: "Pending", isTitle: false },
  ],
  "d06a7029-ddfe-4d14-8ced-ce657df517a8": [
    { title: "SIL Approved", isTitle: true, activeStep: 4 },
    { title: "OMC – Approved", isTitle: true, activeStep: 4 },
    { title: "OMC - NOC", isTitle: true, activeStep: 4 },

    { title: "Initiated", isTitle: false, activeStep: 4 },
    { title: "Pending", isTitle: false, activeStep: 4 },
    { title: "Authority - Approval", isTitle: true, activeStep: 4 },
    { title: "Authority - NOC", isTitle: true, activeStep: 4 },
    { title: "Installation", isTitle: true, activeStep: 4 },
  ],
  "BPCL-GUR-0003": [
    { title: "SIL Approved", isTitle: true, activeStep: 7 },
    { title: "OMC – Approved", isTitle: true, activeStep: 7 },
    { title: "OMC - NOC", isTitle: true, activeStep: 7 },

    // { title: "Initiated", isTitle: false, activeStep: 4 },
    // { title: "Pending", isTitle: false, activeStep: 4 },
    { title: "Authority - Approved", isTitle: true, activeStep: 7 },
    { title: "Authority - NOC", isTitle: true, activeStep: 7 },
    { title: "Installation", isTitle: true, activeStep: 7 },
    { title: "Initiated", isTitle: false, activeStep: 7 },
    { title: "Pending", isTitle: false, activeStep: 7 },
  ],

  // filterActionList: [
  //   { label: "Starts With", value: "startsWith" },
  //   { label: "Ends With", value: "endsWith" },
  //   { label: "Equal to", value: "equals" },
  //   { label: "Contains", value: "contains" },
  //   { label: "Not Equals", value: "notEquals" },
  // ],
  filterFields: [
    { label: "Principle", value: "principle_name" },
    { label: "City", value: "city" },
    { label: "Location Name", value: "location_name" },
    { label: "Landmark", value: "landmark" },
    { label: "Status", value: "status" },
    { label: "Partner Name", value: "partner_name" },
  ],
  filterActionList: [
    { label: "Equals", value: "equals" },
    { label: "Not Equals", value: "notEquals" },
    { label: "Starts With", value: "startsWith" },
    { label: "Ends with", value: "endsWith" },
    { label: "Contains", value: "contains" },
  ],

  tabsSteps: [
    "Principle",
    "Site",
    "Stakeholders",
    "Assets",
    "Commercials",
    "Attachments",
    "Activities",
  ],

  attachmentHeaders: [
    "File Name",
    "Last modified",
    "Size",
    "Content Type",
    "Download Attachment",
  ],
};
export default AppConfig;
